/** @jsx jsx */
import * as React from "react"
import {isEmpty as _isEmpty, get as _get, map as _map} from "lodash"
import { jsx } from "@emotion/core";
import {TherapistPastSessionsStyles} from "../../styles/components/ongoing/therapistPastSession";
import RenderConfidentialData from "../../components/common/RenderConfidentialData"

interface ITherapyDetailsProps {
    data: any
}

const TherapyConsultationDetailView = (props: ITherapyDetailsProps) => {

    return (
        <div>
            {
                _get(props.data, "demographicInformation.demographicInfo", null) && <div css={TherapistPastSessionsStyles.subContainer}>
                    <div css={TherapistPastSessionsStyles.subHeader}>Demographic Information</div>
                    <div>
                        <div css={TherapistPastSessionsStyles.row}>
                            <div css={TherapistPastSessionsStyles.colHeader}>Occupation</div>
                            <div css={TherapistPastSessionsStyles.colHeader}>Sexual Orientation</div>
                            <div css={TherapistPastSessionsStyles.colHeader}>Marital Status</div>
                        </div>
                        <div css={{...TherapistPastSessionsStyles.bodyText, ...TherapistPastSessionsStyles.row}}>
                            <div css={TherapistPastSessionsStyles.col}><RenderConfidentialData><div>{_get(props.data, "demographicInformation.demographicInfo.occupation.displayValue", "")}</div></RenderConfidentialData></div>
                            <div css={TherapistPastSessionsStyles.col}><RenderConfidentialData><div>{_get(props.data, "demographicInformation.demographicInfo.sexualOrientation.displayValue", "")}</div></RenderConfidentialData></div>
                            <div css={TherapistPastSessionsStyles.col}><RenderConfidentialData><div>{_get(props.data, "demographicInformation.demographicInfo.maritalStatus", "")}</div></RenderConfidentialData></div>
                        </div>
                    </div>
                </div>
            }
            {
                !_isEmpty(_get(props.data, "emergencyContact.emergencyContactList", [])) && <div css={TherapistPastSessionsStyles.subContainer}>
                    <div css={TherapistPastSessionsStyles.subHeader}>Emergency Contact</div>
                    <div>
                        <div css={TherapistPastSessionsStyles.row}>
                            <div css={TherapistPastSessionsStyles.colHeader}>Name</div>
                            <div css={TherapistPastSessionsStyles.colHeader}>Relation</div>
                            <div css={TherapistPastSessionsStyles.colHeader}>Number</div>
                        </div>
                        {_map(props.data.emergencyContact.emergencyContactList, (contact) => {
                            return (<div css={{...TherapistPastSessionsStyles.bodyText, ...TherapistPastSessionsStyles.row}}>
                                <div css={TherapistPastSessionsStyles.col}><RenderConfidentialData><div>{contact.name || ""}</div></RenderConfidentialData></div>
                                <div css={TherapistPastSessionsStyles.col}><RenderConfidentialData><div>{contact.relation?.displayValue || ""}</div></RenderConfidentialData></div>
                                <div css={TherapistPastSessionsStyles.col}><RenderConfidentialData><div>{contact.number || ""}</div></RenderConfidentialData></div>
                            </div>)
                        })}
                    </div>
                </div>
            }
            {
                _get(props.data, "presentingProblems.problem.text", null) && <div css={TherapistPastSessionsStyles.subContainer}>
                    <div css={TherapistPastSessionsStyles.subHeader}>Presenting Problems</div>
                    <RenderConfidentialData><div dangerouslySetInnerHTML={{__html: props.data.presentingProblems.problem.text}} /></RenderConfidentialData>
                </div>
            }
            {
                _get(props.data, "familyHistory.history.text", null) && <div css={TherapistPastSessionsStyles.subContainer}>
                    <div css={TherapistPastSessionsStyles.subHeader}>Family History</div>
                    <RenderConfidentialData><div dangerouslySetInnerHTML={{__html: props.data.familyHistory.history.text}} /></RenderConfidentialData>
                </div>
            }
            {
                _get(props.data, "patientHabits.habits.text", null) && <div css={TherapistPastSessionsStyles.subContainer}>
                    <div css={TherapistPastSessionsStyles.subHeader}>Habits</div>
                    <RenderConfidentialData><div dangerouslySetInnerHTML={{__html: props.data.patientHabits.habits.text}} /></RenderConfidentialData>
                </div>
            }
            {
                _get(props.data, "socialHistory.history.text", null) && <div css={TherapistPastSessionsStyles.subContainer}>
                    <div css={TherapistPastSessionsStyles.subHeader}>Social History</div>
                    <RenderConfidentialData><div dangerouslySetInnerHTML={{__html: props.data.socialHistory.history.text}} /></RenderConfidentialData>
                </div>
            }
            {
                _get(props.data, "patientGoals.goals.text", null) && <div css={TherapistPastSessionsStyles.subContainer}>
                    <div css={TherapistPastSessionsStyles.subHeader}>Goals</div>
                    <RenderConfidentialData><div dangerouslySetInnerHTML={{__html: props.data.patientGoals.goals.text}} /></RenderConfidentialData>
                </div>
            }
            <div css={TherapistPastSessionsStyles.subContainer}>
                <div css={TherapistPastSessionsStyles.subHeader}>History of previous therapy</div>
                <RenderConfidentialData><div css={TherapistPastSessionsStyles.bodyText}>{_get(props.data, "historyOfPreviousTherapy.presentHistory.noPresentHistory", true) ? "No History present" : ""}</div></RenderConfidentialData>                
                    {
                        !_isEmpty(_get(props.data, "historyOfPreviousTherapy.therapy")) && (
                            <RenderConfidentialData>
                                <div>
                                    <div css={TherapistPastSessionsStyles.subHeader}>Therapy Visit</div>
                                    <div>
                                        <div css={TherapistPastSessionsStyles.row}>
                                            <div css={TherapistPastSessionsStyles.colHeader}>When</div>
                                            <div css={TherapistPastSessionsStyles.colHeader}>No. of sessions</div>
                                            <div css={TherapistPastSessionsStyles.colHeader}>Reason</div>
                                        </div>
                                        {_map(props.data.historyOfPreviousTherapy.therapy, (therapy) => {
                                            return (<div css={{...TherapistPastSessionsStyles.bodyText, ...TherapistPastSessionsStyles.row}}>
                                                <div css={TherapistPastSessionsStyles.col}><RenderConfidentialData><div>{therapy.when|| ""}</div></RenderConfidentialData></div>
                                                <div css={TherapistPastSessionsStyles.col}><RenderConfidentialData><div>{therapy.noOfSessions || ""}</div></RenderConfidentialData></div>
                                                <div css={TherapistPastSessionsStyles.col}><RenderConfidentialData><div>{therapy.reason || ""}</div></RenderConfidentialData></div>
                                            </div>)
                                        })}
                                    </div>
                                </div>
                            </RenderConfidentialData>
                        )
                    }
                    {
                        !_isEmpty(_get(props.data, "historyOfPreviousTherapy.psychiatry")) && (
                            <RenderConfidentialData>
                                <div>
                                    <div css={TherapistPastSessionsStyles.subHeader}>Psychiatry Visit</div>
                                    <div>
                                        <div css={TherapistPastSessionsStyles.row}>
                                            <div css={TherapistPastSessionsStyles.colHeader}>When</div>
                                            <div css={TherapistPastSessionsStyles.colHeader}>No. of sessions</div>
                                            <div css={TherapistPastSessionsStyles.colHeader}>Reason</div>
                                        </div>
                                        {_map(props.data.historyOfPreviousTherapy.psychiatry, (psychiatry) => {
                                            return (<div css={{...TherapistPastSessionsStyles.bodyText, ...TherapistPastSessionsStyles.row}}>
                                                <div css={TherapistPastSessionsStyles.col}><RenderConfidentialData><div>{psychiatry.when|| ""}</div></RenderConfidentialData></div>
                                                <div css={TherapistPastSessionsStyles.col}><RenderConfidentialData><div>{psychiatry.noOfSessions || ""}</div></RenderConfidentialData></div>
                                                <div css={TherapistPastSessionsStyles.col}><RenderConfidentialData><div>{psychiatry.reason || ""}</div></RenderConfidentialData></div>
                                            </div>)
                                        })}
                                    </div>
                                </div>
                            </RenderConfidentialData>
                        )
                    }                
            </div>
            {
                _get(props.data, "moodAndFunctioning.details.text", null) && <div css={TherapistPastSessionsStyles.subContainer}>
                    <div css={TherapistPastSessionsStyles.subHeader}>Mood and functioning</div>
                    <RenderConfidentialData><div dangerouslySetInnerHTML={{__html: props.data.moodAndFunctioning.details.text}} /></RenderConfidentialData>
                </div>
            }
            {
                _get(props.data, "themesExplored.details.text", null) && <div css={TherapistPastSessionsStyles.subContainer}>
                    <div css={TherapistPastSessionsStyles.subHeader}>Themes explored</div>
                    <RenderConfidentialData><div dangerouslySetInnerHTML={{__html: props.data.themesExplored.details.text}} /></RenderConfidentialData>
                </div>
            }
            {
                !_get(props.data, "riskAssessment.riskPresent.noRisk", true) && <div css={TherapistPastSessionsStyles.subContainer}>
                    <div css={TherapistPastSessionsStyles.subHeader}>Risk Assessment</div>
                    {_get(props.data, "riskAssessment.risksInvolvedDetails.text", null) && <div>
                        <RenderConfidentialData><div dangerouslySetInnerHTML={{__html: props.data.riskAssessment.risksInvolvedDetails.text}} /></RenderConfidentialData>
                    </div>}
                    {_get(props.data, "riskAssessment.safetyPlan.text", null) && <div>
                        <div css={TherapistPastSessionsStyles.subHeader}>Safety Plan</div>
                        <RenderConfidentialData><div dangerouslySetInnerHTML={{__html: props.data.riskAssessment.safetyPlan.text}} /></RenderConfidentialData>
                    </div>}
                    {_get(props.data, "riskAssessment.emergencyPlan.text", null) && <div>
                        <div css={TherapistPastSessionsStyles.subHeader}>Emergency Plan</div>
                        <RenderConfidentialData><div dangerouslySetInnerHTML={{__html: props.data.riskAssessment.emergencyPlan.text}} /></RenderConfidentialData>
                    </div>}
                </div>
            }
            {
                _get(props.data, "assessment.details.text", null) && <div css={TherapistPastSessionsStyles.subContainer}>
                    <div css={TherapistPastSessionsStyles.subHeader}>Assessment</div>
                    <RenderConfidentialData><div dangerouslySetInnerHTML={{__html: props.data.assessment.details.text}} /></RenderConfidentialData>
                </div>
            }
            {
                _get(props.data, "diagnosticImpressions.details.text", null) && <div css={TherapistPastSessionsStyles.subContainer}>
                    <div css={TherapistPastSessionsStyles.subHeader}>Diagnostic Impressions</div>
                    <RenderConfidentialData><div dangerouslySetInnerHTML={{__html: props.data.diagnosticImpressions.details.text}} /></RenderConfidentialData>
                </div>
            }
            {
                _get(props.data, "therapistIntervention.details.text", null) && <div css={TherapistPastSessionsStyles.subContainer}>
                    <div css={TherapistPastSessionsStyles.subHeader}>Therapist intervention</div>
                    <RenderConfidentialData><div dangerouslySetInnerHTML={{__html: props.data.therapistIntervention.details.text}} /></RenderConfidentialData>
                </div>
            }
            {
                _get(props.data, "progressNotes.details.text", null) && <div css={TherapistPastSessionsStyles.subContainer}>
                    <div css={TherapistPastSessionsStyles.subHeader}>Progress notes</div>
                    <RenderConfidentialData><div dangerouslySetInnerHTML={{__html: props.data.progressNotes.details.text}} /></RenderConfidentialData>
                </div>
            }
            {
                !_isEmpty(_get(props.data, "therapistReferral.referral", [])) && <div>
                    <div css={TherapistPastSessionsStyles.subHeader}>Referral</div>
                    <div>
                        <div css={TherapistPastSessionsStyles.row}>
                            <div css={TherapistPastSessionsStyles.colHeader}>Speciality</div>
                            <div css={TherapistPastSessionsStyles.colHeader}>Comments</div>
                        </div>
                        {_map(props.data.therapistReferral.referral, (referralItem) => {
                            return (<div css={{...TherapistPastSessionsStyles.bodyText, ...TherapistPastSessionsStyles.row}}>
                                <div css={TherapistPastSessionsStyles.col}><RenderConfidentialData><div>{referralItem.doctorSpecialityCode?.displayValue || ""}</div></RenderConfidentialData></div>
                                <div css={TherapistPastSessionsStyles.col}><RenderConfidentialData><div>{referralItem.comments || ""}</div></RenderConfidentialData></div>
                            </div>)
                        })}
                    </div>
                </div>
            }
        </div>
    )
}

export default TherapyConsultationDetailView